import script from "./SovaClubStep.vue?vue&type=script&setup=true&lang=js"
export * from "./SovaClubStep.vue?vue&type=script&setup=true&lang=js"

import "./SovaClubStep.vue?vue&type=style&index=0&id=284115ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-284115ac"]])

export default __exports__